const subdomain = { domain: COOKIE.OPP_WIDGET_DOMAIN };
const hasCookie = 'opportunity_preferences';

export { subdomain, hasCookie };
